import { RouterProvider } from "react-router-dom";
import "./App.css";
import { router } from "./Components/Routes/Route";
import { useEffect, useState } from "react";
import EncryptedButton from "./Components/Shared/EncryptedButton";

function App() {
  const [isLanding, setIsLanding] = useState(true);

  useEffect(() => {
    // Simulate a loading delay
    setTimeout(() => {
      setIsLanding(false);
    }, 4000);
  }, []);

  return (
    <div className="">
      {isLanding ? (
        <div className="bg-gray-dark h-[100vh] flex justify-center items-center">
          <EncryptedButton isLanding />
        </div>
      ) : (
        <RouterProvider router={router}></RouterProvider>
      )}
    </div>
  );
}

export default App;
